const WhyChooseSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-blue-50 rounded-full mb-6">
            <i className="ri-award-line text-blue-600 mr-2"></i>
            <span className="text-sm font-medium text-blue-900">I Nostri Vantaggi</span>
          </div>
          <h2 className="text-5xl font-bold text-blue-900 mb-6">
            Perché Scegliere Amaca S.r.l.
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div className="bg-blue-50 rounded-3xl p-10 hover:shadow-xl transition-all">
            <div className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-percent-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Prezzi All'Ingrosso</h3>
            <p className="text-sm text-gray-600 mb-6">Listini Riservati B2B</p>
            <div className="text-center my-8">
              <i className="ri-double-quotes-l text-6xl text-blue-600 opacity-20"></i>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Offriamo i migliori prezzi all'ingrosso del mercato grazie ai nostri rapporti diretti con i produttori. Listini personalizzati per rivenditori e aziende con margini competitivi.
            </p>
          </div>
          
          <div className="bg-blue-50 rounded-3xl p-10 hover:shadow-xl transition-all">
            <div className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-headphone-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Supporto Dedicato</h3>
            <p className="text-sm text-gray-600 mb-6">Consulenza Pre e Post Vendita</p>
            <div className="text-center my-8">
              <i className="ri-double-quotes-l text-6xl text-blue-600 opacity-20"></i>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Il nostro team di esperti è sempre disponibile per consigli tecnici, supporto nella scelta dei prodotti e assistenza post-vendita completa per garantire la tua soddisfazione.
            </p>
          </div>
          
          <div className="relative rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all">
            <img
              src="https://public.readdy.ai/ai/img_res/e7e83163e06b1f2c25bba5e3ab379318.jpg"
              alt="Team Amaca"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
              <h3 className="text-2xl font-bold mb-2">Team Amaca</h3>
              <p className="text-lg">Casandrino, Napoli</p>
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="md:col-span-2 relative rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20delivery%20van%20with%20technology%20company%20branding%20parked%20at%20warehouse%20loading%20dock%20logistics%20and%20shipping%20scene%20with%20cardboard%20boxes%20professional%20distribution%20center%20with%20organized%20inventory%20clean%20industrial%20environment%20emphasizing%20fast%20delivery%20service&width=1000&height=600&seq=amaca-shipping-006&orientation=landscape"
              alt="Spedizioni Rapide"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 via-blue-900/60 to-transparent"></div>
            <div className="absolute inset-0 p-10 flex flex-col justify-center">
              <h3 className="text-3xl font-bold text-white mb-3">Spedizioni Rapide</h3>
              <p className="text-xl text-blue-100 mb-4">Consegne in 24-48h</p>
              <p className="text-white leading-relaxed max-w-lg">
                Spedizioni veloci e sicure in tutta Italia con tracking completo. Consegne espresse per ordini urgenti e gestione logistica professionale.
              </p>
            </div>
          </div>
          
          <div className="space-y-6">
            <div className="bg-blue-50 rounded-3xl p-8 hover:shadow-xl transition-all">
              <div className="text-center mb-6">
                <i className="ri-double-quotes-l text-4xl text-blue-600 opacity-30"></i>
              </div>
              <p className="text-gray-900 font-medium mb-6 leading-relaxed">
                Garanzia Ufficiale su Tutti i Prodotti
              </p>
              <div className="flex items-center">
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-shield-check-line text-white"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">Certificati</p>
                  <p className="text-xs text-gray-600">Garanzia Italia</p>
                </div>
              </div>
            </div>
            
            <div className="bg-blue-50 rounded-3xl p-8 hover:shadow-xl transition-all">
              <div className="text-center mb-6">
                <i className="ri-double-quotes-l text-4xl text-blue-600 opacity-30"></i>
              </div>
              <p className="text-gray-900 font-medium mb-6 leading-relaxed">
                Fatturazione Elettronica Immediata
              </p>
              <div className="flex items-center">
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-file-text-line text-white"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">B2B</p>
                  <p className="text-xs text-gray-600">P.IVA 10914011217</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
